import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a7c051a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Wenn du das Abonnement beendest, wird die Bereitstellung deiner Chatbots eingestellt. Dein Abonnement bleibt bis zum Ende der Laufzeit aktiv. Eventuell erhältst du eine weitere Rechnung, für nutzungsabhängige Kosten. ")
const _hoisted_2 = { class: "cancel-modal-subscription-preview" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Abbrechen")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Abonnement beenden")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "Abonnement wirklich beenden?",
    icon: "cancel",
    variant: "delete"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.name), 1),
        _createElementVNode("h4", null, "Endet am " + _toDisplayString(_ctx.endsAt), 1)
      ])
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_md_button, {
        variant: "filled",
        mode: "delete",
        onClick: _ctx.cancelSubscription
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 512))
}